module.exports = __webpack_public_path__ + "img/Expiry&waste_management.ce937a65.png";